import {
  type ESocialNetwork,
  type ISocialNetworkConfig,
} from '@mahawi/eshop-common/src/types';
import { createSlice } from '@reduxjs/toolkit';

import {
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
} from '../async-state';
import { type ISocialNetworksState } from './types';

export const preloadedState: ISocialNetworksState = {
  inProcess: false,
  configs: [],
};

const socialNetworksSlice = createSlice({
  name: 'SocialNetworks',
  initialState: preloadedState,
  reducers: {
    socialNetworksLoad(state) {
      state.inProcess = true;
    },
    socialNetworksLoadResponse: {
      reducer(state, action: { payload: { configs: ISocialNetworkConfig[] } }) {
        state.inProcess = false;
        state.configs = action.payload.configs;
      },
      prepare(configs: ISocialNetworkConfig[]) {
        return { payload: { configs } };
      },
    },
    socialNetworksSetEnabled: {
      reducer(state) {
        state.inProcess = true;
      },
      prepare(socialNetwork: ESocialNetwork, isEnabled: boolean) {
        return { payload: { socialNetwork, isEnabled } };
      },
    },
    socialNetworksSetEnabledResponse: {
      reducer(state, action: { payload: { configs: ISocialNetworkConfig[] } }) {
        state.inProcess = false;
        state.configs = action.payload.configs;
      },
      prepare(configs: ISocialNetworkConfig[]) {
        return { payload: { configs } };
      },
    },
    socialNetworksUpsert: {
      reducer(state) {
        state.inProcess = true;
      },
      prepare(socialNetwork: ESocialNetwork, name: string, isEnabled: boolean) {
        return { payload: { socialNetwork, name, isEnabled } };
      },
    },
    socialNetworksUpsertResponse: {
      reducer(state, action: { payload: { configs: ISocialNetworkConfig[] } }) {
        state.inProcess = false;
        state.configs = action.payload.configs;
      },
      prepare(configs: ISocialNetworkConfig[]) {
        return { payload: { configs } };
      },
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      requestFailedMatcher('SocialNetworks'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const {
  socialNetworksLoad,
  socialNetworksLoadResponse,
  socialNetworksSetEnabled,
  socialNetworksSetEnabledResponse,
  socialNetworksUpsert,
  socialNetworksUpsertResponse,
} = socialNetworksSlice.actions;
export default socialNetworksSlice.reducer;
